import React from "react";
import axios from "axios";
import { Organizationapplications } from "../../helper/base_url";

const DownloadBrochureButton = ({ brochureName }) => {
  const handleDownload = async () => {
    try {
      const response = await axios.get(
        `${Organizationapplications}?brochureName=${encodeURIComponent(brochureName)}`,
        {
          responseType: "blob",
        }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", brochureName);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Download error:", error);
    }
  };

  return (
     <a
      onClick={handleDownload}
      style={{
      display: "inline-flex",
      alignItems: "center",
      color: "#043885",
      cursor: "pointer",
      textDecoration: "none",
      fontSize: "16px",
    }}
  >
    Download Template
  </a>
  );
};

export default DownloadBrochureButton;
